module.exports = __webpack_public_path__ + "static/media/52950143_2452986651443178_1791500381797220352_o.4cbfe4f0.jpg";